import { Component, OnInit, AfterViewInit } from '@angular/core';
import {UserService} from '../../shared/user.service';
import { ApiDocumentation } from 'src/app/models/ApiDocumentation';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { HttpHeaders } from '@angular/common/http';
import { files } from 'src/app/models/filesModel';
@Component({
  selector: 'app-api-documentation',
  templateUrl: './api-documentation.component.html',
  styleUrls: ['./api-documentation.component.css']
})
export class ApiDocumentationComponent implements OnInit,AfterViewInit {
  theme_color: string;
  ngAfterViewInit(): void {
    
  }
  loader:boolean=false;
  currentApi:string;
  response:any;
  ApiDocumentations:Array<ApiDocumentation>;
  files:Array<files> = new Array<files>();
  constructor(private userService:UserService,private httpService: HttpService) { }

  ngOnInit() {
    this.httpService.themeChange.subscribe(
      data => {
        this.theme_color = data.themeType;
      }
    );
    this.getApiDocumentation();
  }
  
  getApiDocumentation()
  {
    this.loader = true;
    var user = JSON.parse(sessionStorage.userinfo);
    this.userService.getApiDocumentation(user["userEmailId"]).subscribe(success=>{
      this.ApiDocumentations = success;
      this.ApiDocumentations.forEach(item=>{
      item.url = this.httpService.basePath+"/restportal"+item.url;
      });
      setTimeout(this.addEventListener,100);
      this.loader  = false;
    },
    err=>{
      this.loader = false;
      console.log(err);
    });
  }
  addEventListener()
  {
      var prevContent = null ;
      var that = this;
      var coll = document.getElementsByClassName("collapsible");
      for (var i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function() {
          if(prevContent == null || prevContent == undefined)
            prevContent = this;
          else if(prevContent != this)
          {
            prevContent.nextElementSibling.style.maxHeight = null;
            prevContent.nextElementSibling.style.padding = "0px";
            prevContent.classList.remove("active");
            prevContent  = this;
          }
          this.classList.toggle("active");
          var content = this.nextElementSibling;
          if (content.style.maxHeight){
            content.style.maxHeight = null;
            content.style.padding = "0px";
          } else {
            content.style.maxHeight = "600px";
            content.style.padding = "25px";
          } 
        });
    }
  }
  executeApi(documentation:ApiDocumentation)
  {
    if(documentation.url.indexOf('{')>0 || documentation.url.indexOf('}') >0)
    {
      alert('Please provide proper url parameters.')
      return;
    }  
    this.response = null;
    this.currentApi = documentation.url;
    this.loader = true;
    if(documentation.requestBody != undefined && documentation.requestType=="form-data" || documentation.method == "PUT" || documentation.method == "DELETE" )
      this.createFormAndExecute(documentation);
    else // will be raw data
      this.createJsonAndExecute(documentation);
  }
  addFile(ev,documentation:ApiDocumentation,name:string)
  {
    let file:files = new files();
    file.name = name;
    file.fileList = ev.target.files;
    var index = this.files.findIndex(x=>x.name == name);
    if(index>=0)
      this.files[index] = file;
    else
      this.files.push(file);
  }
  changeValue(obj,documentation:ApiDocumentation,name:string,changePlace:string)
  {
    if(changePlace=='url')
    {
      documentation.url = obj.target.value;
    }
    else
    {
      var changable = documentation[changePlace].filter(x=>x.name==name);
      if(changable.length>0)
      {
        changable[0].defaultValue = obj.target.value;
      }
    }
    
  }
  createFormAndExecute(documentation:ApiDocumentation)
  {
    
     var formData = new FormData();
     var json= "";
     //formData. = "multipart/form-data";
     documentation.requestBody.forEach(item=>{
      if(item.type == "File")
       {
        var files = this.files.filter(x=>x.name == item.name);
        if(files.length>0)
        {
          for(var i=0;i<files[0].fileList.length;i++)
          {
           formData.append(item.name,files[0].fileList[i],files[0].fileList[i].name);
          
          }
        }
       }
       else if(item.type=="JSON")
       {
        var json =JSON.parse(''+item.defaultValue+'');
        formData.append(item.name,JSON.stringify(json));
       }
     });
     let headers = new HttpHeaders();
    documentation.headers.forEach(item=>{
      headers= headers.set(item.name, item.defaultValue);
    });
    headers = headers.append("APIDocumentation","1");
    if(documentation.requestType == "raw")
      json =  JSON.parse(''+documentation.requestBody[0].defaultValue+'');
    this.executeRawApi(documentation.url,formData,headers,documentation.method,documentation.requestType,json);
  }
  executeRawApi(url:string,formData:FormData,headers:any,requestMethod:string,requestType:string,body:any)
  {
    this.loader  = true;
    if(requestMethod == "POST")
    {
      this.httpService.executeApiTestPostWithFormData(url,formData,headers).subscribe(res=>{
        console.log(res);
        this.response = res;
        this.loader = false;
      },
      err=>{
        this.response = err;
        console.log(err);
        this.loader = false;
      })
    }
    else if(requestMethod=="PUT")
    {
      if(requestType == "raw")
      {
        this.httpService.executeApiTestPutWithRawData(url,JSON.stringify(body),headers).subscribe(res=>{
          this.response = res;
          this.loader = false;
        },
        err=>{
          this.response = err;
          this.loader = false;
        })
      }
      else
      {
        this.httpService.executeApiTestPutWithFormData(url,formData,headers).subscribe(res=>{
          this.response = res;
          this.loader = false;
        },
        err=>{
          this.response = err;
          this.loader = false;
        })
      }
    }
    else if(requestMethod == "DELETE")
    {
      this.httpService.executeApiTestDelete(url,headers).subscribe(res=>{
        this.response = res;
        this.loader = false;
      },
      err=>{
        this.response = err;
        this.loader = false;
      })
    }
  }
  createJsonAndExecute(documentation:ApiDocumentation)
  {
    this.loader = true;
    if(documentation.requestBody.length>0)
      var json =JSON.parse(''+documentation.requestBody[0].defaultValue+'');
    let headers = new HttpHeaders();
    documentation.headers.forEach(item=>{
      headers= headers.set(item.name, item.defaultValue);
    });
    headers = headers.append("APIDocumentation","1");
    if(documentation.method == "GET")
    {
      if(documentation.requestType == "raw")
      {
        this.httpService.executeApiTestPostWithRawBody(documentation.url,JSON.stringify(json),headers).subscribe(res=>{
          this.response = res;
          console.log(res);
          this.loader = false;
        },
        err =>{
          this.response = err;
          console.log(err);
          this.loader = false;
        });
      }
      if(documentation.requestType=="none")
      {
        this.httpService.executeApiTestGetRequest(documentation.url,headers).subscribe(res=>{
          this.response = res;
          this.loader = false;
        },
        err=>{
            if(err.message.toLowerCase().indexOf("http failure during parsing")>-1)//this means content downloaded but browser cant parse this because it is not files browser can recognise by default.
            {
              err.error.text = err.error.text.substr(0,10000);//to avoid memory issues with large files , showing only part of file.
              this.response = err;
              this.loader = false;
            }
            else
            {
              this.response = err;
              this.loader = false;
            }
        });
      }
    }
    else if(documentation.method =="POST")
    {
      if(documentation.requestType == "raw")
      {
        this.httpService.executeApiTestPostWithRawBody(documentation.url,JSON.stringify(json),headers).subscribe(res=>{
          this.response = res;
          console.log(res);
          this.loader = false;
        },
        err =>{
          this.response = err;
          console.log(err);
          this.loader = false;
        });
      }
    }
  }
}
